import { render, staticRenderFns } from "./forceTypeEdit.vue?vue&type=template&id=5d365996&scoped=true"
import script from "./forceTypeEdit.vue?vue&type=script&lang=js"
export * from "./forceTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./forceTypeEdit.vue?vue&type=style&index=0&id=5d365996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d365996",
  null
  
)

export default component.exports